module.exports = __webpack_public_path__ + "static/img/princess.fe58f20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/collage/papercuts/princess.jpg
// module id = 6Bne
// module chunks = 1